<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <i-input prefix="ios-search" placeholder="输入站点名称查询" v-model="search.name" style="width: auto" />
        <i-button type="default" @click="getData" style="margin-left: 1em;">搜索</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
        <FormItem label="站点编号:" prop="mn">
          <Select clearable style="margin-right: 20px;" @on-change="getDevice($event)" v-model="formValidate.mn">
            <Option v-for="prop in siteList" :key="prop.id" :value="prop.mn">{{ prop.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="流程设备:" prop="deviceIdList">
          <Select clearable multiple style="margin-right: 20px;" v-model="formValidate.deviceIdList">
            <Option v-for="prop in deviceList" :key="prop.id" :value="prop.id">{{ prop.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="流程名称:" prop="name">
          <i-input v-model="formValidate.name" placeholder="输入名称"></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}
</style>

<script>
import toolbar from "../toolBar.vue";
import { timeStamp } from "../../../util/common/date";
import LoadImg from "../../../components/Load_img.vue";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center"
          },
          {
            title: "站点名称",
            key: "mnName",
            align: "center"
          },
          {
            title: "流程名称",
            key: "name",
            align: "center"
          },
          {
            title: "流程设备",
            key: "deviceNames",
            align: "center"
          },
          {
            title: "创建时间",
            key: "createDate",
            align: "center",
            render(h, params) {
              return h("span", {}, timeStamp(params.row.createDate));
            }
          },
          {
            title: "操作",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误

                        // 将字符串转换为数组 绑定设备数据
                        if (params.row.masterDevices) {
                          this.deviceCheck = params.row.masterDevices.split(
                            ","
                          );
                          for (
                            let i = 0, length = this.deviceCheck.length;
                            i < length;
                            i++
                          ) {
                            this.deviceCheck[i] = parseInt(this.deviceCheck[i]);
                          }
                        }

                        this.modal.siteAble = true;
                        this.updataDeviceList(params.row.mn).then(res => {
                          this.formValidate = {
                            id: params.row.id,
                            mn: params.row.mn, // 站点编号 必填
                            name: params.row.name, // 站点名称 必填
                            deviceIdList: params.row.deviceIdList
                          };
                        })

                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        data: [],
        pageCurrent: 1,
        pageSize: 10,
        total: 0,
        loading: true,
        isSystem_loading: false, // 切换启用状态loading
        inMaintenance_loading: false // 切换运维状态
      },
      // 查询
      search: {
        name: null
      },
      // 表单
      modal: {
        show: false,
        title: "添加",
        siteAble: false
      },
      // 表单数据
      formValidate: {
        mn: "", // 站点编号 必填
        name: null, // 流程名称 必填
        deviceIdList: [] //流程设备
      },
      deviceMap: {},
      siteMap: {},
      // 用户列表
      userList: [],
      // 所有设备列表
      allDeviceList: [],
      // 站点对应设备列表
      deviceList: [],
      // 已选设备
      deviceCheck: [],
      // 所有站点枚举列表
      siteList: [],
      // 验证
      ruleValidate: {
        mn: [{ required: true, message: "不能为空", trigger: "blur" }],
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        deviceIdList: [
          { required: true, type: 'array', message: "不能为空", trigger: "blur" }
        ]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      }
    };
  },
  components: {
    toolbar,
    LoadImg
  },
  created() {

    // this.getUserList();
    this.getDeviceList();
    this.getAllSite(); // 获取所有站点
  },
  computed: {},
  methods: {
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.modal.siteAble = false;
      //console.log(this.deviceList)
      this.deviceList = []
      this.formValidate = {
        mn: "", // 站点编号 必填
        deviceIdList: [], // 流程设备 必填
        name: "",  //流程名称
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Deploy.getProcessList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            item.mnName = this.siteMap[item.mn] || ''; 
            item.deviceNames = item.deviceIdList.map(id => this.deviceMap[id]).join(' || ');
          });
          //console.dir(res.data.list);
          this.table.data = res.data.list;

          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    getDeviceList() {
      this.$api.Enum.getDeviceEnum(null, ["uuid", "company"]).then(res => {
        if (res.code === 0) {
          let data = res.data;
          data.forEach(item => {
            this.deviceMap[item.id] = item.name;
          });

          this.getData(); // 数据初始化
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Deploy.getProcesstDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message ? res.message : "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Deploy.postProcessAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Deploy.postProcessEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    // 绑定设备发生变化时 对表单重新赋值
    deviceCheckChange(array) {
      this.formValidate.masterDevices = array.join();
    },
    imgLoadSuccess(url) {
      // img回调
      this.formValidate.imgUrl = url;
    },
    // img删除回调
    imgLoadDel() {
      this.formValidate.imgUrl = null;
    },
    getAllSite() {
      this.$api.Enum.getSiteEnum(null, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.siteList = res.data;
          res.data.forEach(item => {
            this.siteMap[item.mn] = item.name;
          });
        }
      });
    },
    // 表单操作 选择站点后获取设备
    getDevice(siteMn) {
      //console.log(siteMn);
      this.formValidate.deviceIdList = []
      let data = this.formPortList;
      if (siteMn != undefined) {
        this.$api.Enum.getDeviceEnum({ content: { mn: siteMn } }, ["uuid", "company"]).then(res => {
          if (res.code == 0) {
            let data = res.data;
            this.deviceList = data;
          }
        });
      }
    },
    // 更新设备
    updataDeviceList(siteMn) {
      return new Promise((resovle, reject) => {
        this.$api.Enum.getDeviceEnum({ content: { mn: siteMn } }, ["uuid", "company"]).then(res => {
          if (res.code == 0) {
            let data = res.data;
            this.deviceList = data;
            resovle()
          }
        });
      })
    }
  }
};
</script>